'use strict';

bbw.directive.BbwPostLikesController = Class({

    $inject: ['$scope', '$fancyModal'],

    construct: function($scope, $fancyModal) {
        this.$scope = $scope;
        this.$fancyModal = $fancyModal;
    },

    toggleLike: function() {
        this.$scope.onToggleLike();
    },

    openModal: function() {
        this.$scope.entity.$model.loadAllLikes().then(function() {
            this.$fancyModal.open({
                templateUrl: bbw.templateUrl('modal-post-likes.html'),
                scope: this.$scope.$new()
            });
        }.bind(this));
    }

});

bbw.directive.bbwPostLikes = function() {
    return {
        scope: {
            'canLike': '=',
            'onToggleLike': '&',
            'entity': '=bbwPostLikes'
        },
        templateUrl: bbw.templateUrl('post-likes.html'),
        controller: bbw.directive.BbwPostLikesController,
        controllerAs: 'ctrl'
    }
};
